import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { selectUser } from '../ngrx/data.reducer';

@Injectable({
  providedIn: 'root',
})
export class CreatorGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let userDetails: any;

    this.store
      .select(selectUser)
      .pipe(
        take(1),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        userDetails = user;
      });

    if (!userDetails || !userDetails.userTypeId) {
      // Redirect to signin and save attempted URL
      this.router.navigate(['/signin'], {
        queryParams: { previousurl: state.url },
      });
      return false; // Important: stop activation
    }

    if (userDetails.userTypeId !== 1) {
      this.router.navigate(['/fan/emeetings']);
      return false;
    }

    // console.log('userDetails in CreatorGuard: ', userDetails);
    return true;
  }
}
